import { defineMessages } from 'react-intl';

/** The copy of the Media block in the Creator (design smartlink-media-block a, d). */
export const mediaBlockMessages = defineMessages({
  title: { id: 'app.sml.smartlinks.blocks.media.title', defaultMessage: 'Media block' },
  file: { id: 'app.sml.smartlinks.blocks.media.file', defaultMessage: 'File' },
  emptyBody: {
    id: 'app.sml.smartlinks.blocks.media.empty.body',
    defaultMessage: 'Make a video or an image in the Studio, then pick it here. Or upload a file.',
  },
  emptyNote: {
    id: 'app.sml.smartlinks.blocks.media.empty.note',
    defaultMessage: 'A file that renders now shows here when it is ready.',
  },
  changeFile: { id: 'app.sml.smartlinks.blocks.media.changeFile', defaultMessage: 'Change file' },
  newestRevision: {
    id: 'app.sml.smartlinks.blocks.media.newestRevision',
    defaultMessage: 'The page always shows the newest ready revision of this file.',
  },
  cover: { id: 'app.sml.smartlinks.blocks.media.cover', defaultMessage: 'Cover' },
  coverNote: {
    id: 'app.sml.smartlinks.blocks.media.cover.note',
    defaultMessage: 'The page always shows the cover of the song now. A new cover shows with no edit.',
  },
  allSongs: { id: 'app.sml.smartlinks.blocks.media.allSongs', defaultMessage: 'All songs' },
  allSongsEmpty: {
    id: 'app.sml.smartlinks.blocks.media.allSongs.empty',
    defaultMessage: 'No song has a cover or a ready file yet.',
  },
  uploadedFile: { id: 'app.sml.smartlinks.blocks.media.uploadedFile', defaultMessage: 'Uploaded file' },
  uploadedPicture: { id: 'app.sml.smartlinks.blocks.media.uploadedPicture', defaultMessage: 'Picture' },
  uploadedVideo: { id: 'app.sml.smartlinks.blocks.media.uploadedVideo', defaultMessage: 'Video' },
  noFile: { id: 'app.sml.smartlinks.blocks.media.noFile', defaultMessage: 'Pick a file or upload one.' },
  playback: { id: 'app.sml.smartlinks.blocks.media.playback', defaultMessage: 'Playback' },
  autoplay: { id: 'app.sml.smartlinks.blocks.media.autoplay', defaultMessage: 'Play muted when it shows' },
  autoplayNote: {
    id: 'app.sml.smartlinks.blocks.media.autoplay.note',
    defaultMessage: 'Starts with no sound when the fan scrolls to it. A tap turns on the sound.',
  },
  loop: { id: 'app.sml.smartlinks.blocks.media.loop', defaultMessage: 'Loop' },
  controls: { id: 'app.sml.smartlinks.blocks.media.controls', defaultMessage: 'Show the controls' },
  controlsNote: {
    id: 'app.sml.smartlinks.blocks.media.controls.note',
    defaultMessage: 'Play, pause, sound and the time bar.',
  },
  look: { id: 'app.sml.smartlinks.blocks.media.look', defaultMessage: 'Look and text' },
  shape: { id: 'app.sml.smartlinks.blocks.media.shape', defaultMessage: 'Shape' },
  shapeOriginal: { id: 'app.sml.smartlinks.blocks.media.shape.original', defaultMessage: 'Original' },
  fit: { id: 'app.sml.smartlinks.blocks.media.fit', defaultMessage: 'Fit' },
  fitCover: { id: 'app.sml.smartlinks.blocks.media.fit.cover', defaultMessage: 'Fill' },
  fitContain: { id: 'app.sml.smartlinks.blocks.media.fit.contain', defaultMessage: 'Show all' },
  caption: { id: 'app.sml.smartlinks.blocks.media.caption', defaultMessage: 'Caption' },
  captionPlaceholder: { id: 'app.sml.smartlinks.blocks.media.caption.placeholder', defaultMessage: 'Optional' },
  link: { id: 'app.sml.smartlinks.blocks.media.link', defaultMessage: 'Tap opens (optional)' },
  linkNote: {
    id: 'app.sml.smartlinks.blocks.media.link.note',
    defaultMessage: 'A tap counts as a click of this block.',
  },
  invalid: {
    id: 'app.sml.smartlinks.blocks.media.invalid',
    defaultMessage: 'Check the fields. The address must start with https:// and the caption can have 200 characters.',
  },
  optionAutoplay: { id: 'app.sml.smartlinks.blocks.media.option.autoplay', defaultMessage: 'autoplay muted' },
  optionTapToPlay: { id: 'app.sml.smartlinks.blocks.media.option.tapToPlay', defaultMessage: 'tap to play' },
  optionOpens: { id: 'app.sml.smartlinks.blocks.media.option.opens', defaultMessage: 'opens {host}' },
  hiddenFileGone: {
    id: 'app.sml.smartlinks.blocks.media.hidden.fileGone',
    defaultMessage: 'Hidden on the page: the file is gone',
  },
  hiddenSongGone: {
    id: 'app.sml.smartlinks.blocks.media.hidden.songGone',
    defaultMessage: 'Hidden on the page: the song left the Catalog',
  },
  hiddenRendering: {
    id: 'app.sml.smartlinks.blocks.media.hidden.rendering',
    defaultMessage: 'Shows on the page when it is ready',
  },
  fileGoneBody: {
    id: 'app.sml.smartlinks.blocks.media.problem.fileGone',
    defaultMessage: 'The file of this block is gone, so fans do not see the block.',
  },
  songGoneBody: {
    id: 'app.sml.smartlinks.blocks.media.problem.songGone',
    defaultMessage: 'The song of this block left the Catalog, so fans do not see the block.',
  },
  renderingBody: {
    id: 'app.sml.smartlinks.blocks.media.problem.rendering',
    defaultMessage: 'The file renders now. The block shows on the page when it is ready.',
  },
  pickAnother: { id: 'app.sml.smartlinks.blocks.media.pickAnother', defaultMessage: 'Pick another file' },
  deleteBlock: { id: 'app.sml.smartlinks.blocks.media.delete', defaultMessage: 'Delete block' },
  newerRendering: {
    id: 'app.sml.smartlinks.blocks.media.newerRendering',
    defaultMessage:
      'r{next} renders now ({progress}%). The page keeps r{current} until r{next} is ready, then shows r{next}.',
  },
  newerRenderingNoNumber: {
    id: 'app.sml.smartlinks.blocks.media.newerRendering.noNumber',
    defaultMessage: 'A new revision renders now ({progress}%). The page keeps this one until it is ready.',
  },
});
